import { quoteApi } from '@/main/api';
import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import ResultNotFoundComponent from '@/main/components/shared/resultNotFound/resultNotFoundComponent';
import { QuoteHeaderAnswerInformationResponse } from '@/main/models/response';
import CreateAnswerCartsScreen from '@/main/screens/quotation/createAnswer/answeredParts/createAnswerScreen';
import { AxiosError } from 'axios';
import { useEffect, useRef, useState } from 'react';

import * as S from './answeredParts/styles';
import { getTranslateByKey } from '@/main/services/utils';
import { useSearchParams } from 'react-router-dom';
import { CreateAnswerImageScreen } from '@/main/screens/quotation/createAnswer/createAnswerImage/createAnswerImageScreen';

const INITIAL_DATA_HEADER: QuoteHeaderAnswerInformationResponse = {
  code: '',
  claimNumber: '',
  statusName: '',
  insurerCompanyName: '',
  bodyShopCompanyName: '',
  vehicle: '',
  vehicleRegistration: '',
  deliveryAddress: '',
  guidQuote: '',
  guidAddress: '',
  guidSupplier: '',
  deadlineAnswer: '',
  startDate: '',
  idQuoteSuppItemStatus: 0,
  guidCountry: '',
  bodyshopContactName: '',
  bodyshopEmail: '',
  bodyshopPhoneNr: '',
  vin: '',
  isNagsCodeCall: false
};
export default function CreateAnswerScreenWrapper() {
  const [dataHeader, setDataHeader] =
    useState<QuoteHeaderAnswerInformationResponse>(INITIAL_DATA_HEADER);

  const [isLoadingHeader, setIsLoadingHeader] = useState<boolean>(false);

  const [messageErrorScreen, setMessageErrorScreen] = useState<string | null>(
    null
  );

  const [isFinishedTime, setIsFinishedTime] = useState<boolean>(false);

  const [searchParams, _] = useSearchParams();
  const wasExpiredAtLoadRef = useRef<boolean>(false);

  const guidQuoteParams = searchParams.get('guidQuote') || '';
  const imageMode = searchParams.get('imageMode') || false;

  function isDeadlineExpired(finishTime: string): boolean {
    if (!finishTime) return false;
    const now = new Date();
    const finish = new Date(finishTime);
    const nowInUtc = new Date(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
    return finish.getTime() - nowInUtc.getTime() <= 0;
  }

  function handleFinishTime() {
    setIsFinishedTime(true);
    if (!wasExpiredAtLoadRef.current) {
      window.location.reload();
    }
  }

  async function loadHeader(guidQuote: string) {
    setIsLoadingHeader(true);
    setMessageErrorScreen(null);
    quoteApi
      .headeranswerinformation(guidQuote)
      .then(response => {
        const { result } = response.data;
        wasExpiredAtLoadRef.current = isDeadlineExpired(result.deadlineAnswer);
        setDataHeader(result);
      })
      .catch((error: AxiosError<any>) => {
        let errorMessagesValue: string[] = [];
        if (
          error?.response?.data?.errors?.guid &&
          error?.response?.data?.errors?.guid.length > 0
        ) {
          errorMessagesValue = error?.response?.data?.errors?.guid;
          setMessageErrorScreen(errorMessagesValue[0]);
        }
      })
      .finally(() => {
        setIsLoadingHeader(false);
      });
  }

  const titleScreen = `${getTranslateByKey(
    'screen.quotation'
  )} > ${getTranslateByKey('screen.answeredcarts')}`;

  const titleScreenImage = `${getTranslateByKey(
    'screen.quotation'
  )} > ${getTranslateByKey('information.claimImages')}`;

  useEffect(() => {
    if (!guidQuoteParams)
      return setMessageErrorScreen(
        getTranslateByKey('information.requiredParameter', true).replace(
          '{0}',
          'guidQuote'
        )
      );
    if (guidQuoteParams) loadHeader(guidQuoteParams);
  }, [guidQuoteParams]);

  if (messageErrorScreen)
    return (
      <ContainerScreen
        id="id-createAnswerCarts-menssage-Error"
        title={titleScreen}>
        <S.ContainerError>
          <ResultNotFoundComponent messageCustom={messageErrorScreen} />
        </S.ContainerError>
      </ContainerScreen>
    );

  if (imageMode) {
    return (
      <CreateAnswerImageScreen
        dataHeader={dataHeader}
        isLoadingHeader={isLoadingHeader}
        titleScreen={titleScreenImage}
        guidQuoteParams={guidQuoteParams}
        isFinishedTime={isFinishedTime}
        handleFinishTime={handleFinishTime}
      />
    );
  } else {
    return (
      <CreateAnswerCartsScreen
        dataHeader={dataHeader}
        isLoadingHeader={isLoadingHeader}
        loadHeader={loadHeader}
        titleScreen={titleScreen}
        guidQuoteParams={guidQuoteParams}
        isFinishedTime={isFinishedTime}
        handleFinishTime={handleFinishTime}
      />
    );
  }
}
